import type { IHomeLoanReviewProductReward } from './HomeLoanReviewProductReward.interface';

export default class HomeLoanReviewProductReward implements IHomeLoanReviewProductReward {
  description: string;
  points: string;
  hasRewards: boolean;

  static build = (data: IHomeLoanReviewProductReward) => new HomeLoanReviewProductReward(data);
  static blank = () => new HomeLoanReviewProductReward();

  /**
   * Constructor
   * @param {IHomeLoanReviewProductReward} data
   */
  constructor(data?: IHomeLoanReviewProductReward) {
    this.description = data?.description || '';
    this.points = data?.points || '';
    this.hasRewards = data?.hasRewards === true;
  }
}
